export const useSecureShoppingImages = () => {
  const secureShoppingSmallIcons = [
    {
      srcDpr1: 'https://cdn-images.italist.com/image/upload/c_scale,h_20,q_auto:best/v1579171284/icons/visa.jpg',
      srcDpr2: 'https://cdn-images.italist.com/image/upload/c_scale,h_20,dpr_2,q_auto:best/v1579171284/icons/visa.jpg',
      width: '26px',
    },
    {
      srcDpr1:
        'https://cdn-images.italist.com/image/upload/c_scale,h_20,q_auto:best/v1579106023/icons/visa_electron.jpg',
      srcDpr2:
        'https://cdn-images.italist.com/image/upload/c_scale,h_20,dpr_2,q_auto:best/v1579106023/icons/visa_electron.jpg',
      width: '32px',
    },
    {
      srcDpr1: 'https://cdn-images.italist.com/image/upload/c_scale,h_20,q_auto:best/v1579106023/icons/jcb.png',
      srcDpr2: 'https://cdn-images.italist.com/image/upload/c_scale,h_20,dpr_2,q_auto:best/v1579106023/icons/jcb.png',
      width: '32px',
    },
    {
      srcDpr1: 'https://cdn-images.italist.com/image/upload/c_scale,h_20,q_auto:best/v1579171288/icons/mastercard.png',
      srcDpr2:
        'https://cdn-images.italist.com/image/upload/c_scale,h_20,dpr_2,q_auto:best/v1579171288/icons/mastercard.png',
      width: '33px',
    },
  ];
  return { secureShoppingSmallIcons };
};
